
import { defineComponent, onMounted, ref } from "vue";
import DevicesTable from "@/components/widgets/sistena/ModelsTable.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "account-overview",
  props:{
    model: String
  },
  components: {
    DevicesTable
  },
  setup() {
    const list = ref([]);
    const fetchModels = async () => {
      await ApiService.setHeader();
      const models = await ApiService.get("models");
      list.value = models.data;
      console.log(list.value);
    };
    onMounted(() => {
      setCurrentPageBreadcrumbs("Overview", ["Account"]);
    });
    return {
      list,
      fetchModels
    };
  },
  created() {
    this.fetchModels();
  }
});
